class ScrollingHero {
	element: HTMLElement;
	title: HTMLElement;
	titleContainer: HTMLElement;
	titleClipped: HTMLElement;
	clipSection: HTMLElement;
	videoContainer: HTMLElement;
	titleTrack: HTMLElement;
	content: HTMLElement;
	videoButton: HTMLElement;
	iframe: HTMLIFrameElement;
	scrollDown: HTMLElement;

	constructor(element: HTMLElement) {
		this.element = element;
		this.title = element.querySelector('.block-scrolling-hero__title') as HTMLElement;
		this.titleContainer = element.querySelector(
			'.block-scrolling-hero__title-container'
		) as HTMLElement;
		this.titleClipped = element.querySelector(
			'.block-scrolling-hero__title.clipped'
		) as HTMLElement;
		this.clipSection = element.querySelector('.block-scrolling-hero__main') as HTMLElement;
		this.videoContainer = element.querySelector(
			'.block-scrolling-hero__video-container'
		) as HTMLElement;
		this.titleTrack = element.querySelector(
			'.block-scrolling-hero__title-track'
		) as HTMLElement;
		this.content = element.querySelector('.block-scrolling-hero__content') as HTMLElement;
		this.videoButton = element.querySelector(
			'.block-scrolling-hero__video-button'
		) as HTMLElement;
		this.iframe = element.querySelector('iframe') as HTMLIFrameElement;
		this.scrollDown = element.querySelector('.scroll-down') as HTMLElement;
	}

	init() {
		window.addEventListener('scroll', this.updateClip.bind(this), { passive: false });
		window.addEventListener('resize', () => {
			this.updateElement();
		});
		window.addEventListener('scroll', this.updateOpacity.bind(this));
		window.addEventListener('scroll', this.updateScrollDownGradient.bind(this));
		window.addEventListener('DOMContentLoaded', this.updateElement.bind(this));
	}

	updateElement() {
		this.updateScrollDownGradient();
		this.updateTitleTrackHeight();
		this.updateClip();
	}

	updateClip() {
		const heroBottomY = this.titleClipped.getBoundingClientRect().bottom;
		const videoTopY = this.clipSection.getBoundingClientRect().top;
		const clipPixel = heroBottomY - videoTopY;
		this.titleClipped.style.clipPath = `inset(0 0 ${clipPixel}px 0)`;
	}

	updateTitleTrackHeight() {
		if (!this.titleTrack || !this.content) return;
		const trackRect = this.titleTrack.getBoundingClientRect();
		const contentRect = this.content.getBoundingClientRect();
		const scrollY = window.scrollY || window.pageYOffset;
		const trackTop = trackRect.top + scrollY;
		const contentTop = contentRect.top + scrollY;
		const height = Math.max(0, contentTop - trackTop);
		this.titleTrack.style.height = `${height}px`;
	}

	updateOpacity() {
		const titleContainer = this.titleContainer;
		const titleTrack = this.titleTrack;
		const videoContainer = this.videoContainer;
		if (!titleContainer || !titleTrack) return;

		const containerRect = titleContainer.getBoundingClientRect();
		const trackRect = titleTrack.getBoundingClientRect();
		const distanceFromTop = containerRect.top - trackRect.top;
		const videoContainerRect = videoContainer.getBoundingClientRect();
		const fadeDistance = trackRect.height * 0.15;
		const distanceFromContent = containerRect.top - videoContainerRect.top;
		const contentFadeDistance = videoContainerRect.height * 0.1;
		// fade out title container when title is 10% past video container
		if (distanceFromContent > contentFadeDistance) {
			titleContainer.style.opacity = '0';
		} else {
			titleContainer.style.opacity = '1';
		}

		// expand width of video container when 15% of title track is scrolled
		if (distanceFromTop >= fadeDistance) {
			this.videoContainer.classList.add('is-visible');
		} else {
			this.videoContainer.classList.remove('is-visible');
		}
	}

	updateScrollDownGradient() {
		if (!this.scrollDown || !this.titleContainer) return;

		const scrollDownRect = this.scrollDown.getBoundingClientRect();
		const titleContainerRect = this.titleContainer.getBoundingClientRect();

		if (titleContainerRect.bottom <= scrollDownRect.top) {
			this.scrollDown.style.opacity = '1';
			this.scrollDown.style.maskImage = 'none';
			this.scrollDown.style.webkitMaskImage = 'none';
			return;
		}

		if (titleContainerRect.bottom >= scrollDownRect.bottom) {
			this.scrollDown.style.opacity = '0';
			return;
		}

		const overlapHeight = titleContainerRect.bottom - scrollDownRect.top;
		const scrollDownHeight = scrollDownRect.height;
		const overlapPercentage = Math.min(overlapHeight / scrollDownHeight, 1);

		const gradientStart = overlapPercentage * 100;
		this.scrollDown.style.opacity = '1';
		this.scrollDown.style.maskImage = `linear-gradient(to bottom, transparent 0%, transparent ${gradientStart}%, rgba(0,0,0,1) 100%)`;
		this.scrollDown.style.webkitMaskImage = `linear-gradient(to bottom, transparent 0%, transparent ${gradientStart}%, rgba(0,0,0,1) 100%)`;
	}
}

document.querySelectorAll('.block-scrolling-hero').forEach((element) => {
	const scrollingHero = new ScrollingHero(element as HTMLElement);
	scrollingHero.init();
});
